export default {
  common: {
    siteName: "AllChinaBuy Spreadsheet",
    siteTagline: "Funde, Guides & Ressourcen",
    disclaimer: "Unabhängige Ressource — nicht mit AllChinaBuy verbunden",
    nav: {
      home: "Startseite",
      categories: "Kategorien",
      guides: "Guides",
      shoppingGuide: "Kaufguide",
      safety: "Sicherheit",
    },
    lang: {
      label: "Sprache",
      en: "English",
      fr: "Français",
      da: "Dansk",
      de: "Deutsch",
    },
    buttons: {
      buyNow: "Jetzt kaufen",
      mainCta: "AllChinaBuy Spreadsheet",
      explore: "Entdecken",
      visitMain: "Hauptwebsite besuchen",
      readGuide: "Guide lesen",
      backHome: "Zurück zur Startseite",
      learnMore: "Mehr erfahren",
    },
    categories: {
      shoes: "Schuhe",
      hoodies: "Hoodies/Sweatshirts",
      tshirts: "T-Shirts",
      jackets: "Jacken",
      pants: "Hosen/Shorts",
      headwear: "Kopfbedeckungen",
      sets: "Sets",
      underwear: "Unterwäsche/Unterhosen",
      jersey: "Trikots",
      accessories: "Accessoires",
      bags: "Taschen",
      belts: "Gürtel",
      perfumes: "Parfums",
      other: "Sonstiges",
    },
    footer: {
      about: "AllChinaBuy Spreadsheet ist ein unabhängiges Informations-Hub, das Käufern hilft, organisierte Ressourcen, Produktfunde, Kaufguides, Versandtipps und QC-Informationen zu entdecken.",
      explore: "Entdecken",
      resources: "Ressourcen",
      home: "Startseite",
      guide: "Kompletter Guide",
      categoriesLabel: "Kategorien",
      legal: "Rechtliches",
      privacy: "Datenschutz",
      terms: "Bedingungen",
      affiliate: "Affiliate-Offenlegung",
      copyright: "Alle Rechte vorbehalten.",
      independent: "Diese Website ist eine unabhängige Ressource und weder mit AllChinaBuy verbunden noch von AllChinaBuy unterstützt.",
    },
  },
};